import { PureComponent } from 'react';
import { upsertMedication } from '../store/actions/prescriptionPad';
import { MedicationsEntity } from '../store/types/prescription';
import MedTableRenderer from '../components/prescriptionPad/rightPanel/workspace/padV2/MedTableRenderer';
import { MY_PROFILE_CONTAINER } from './Settings';
import { Modal } from 'antd';
import { GenieItem, GMedication } from '../store/db';
import { EkaFocosableElement } from '../components/common/types/EkaFocusable';
import { connect } from 'react-redux';
import { GlobalState } from '../store/reducers';
import { getGenieSetting } from '../store/selectors/session';
import { GeniePadElementsSettingItem } from '../api/pushGenie';

export type GenieMedTableProps = {
    onSave: (medicationElement: GMedication) => void;
    clearElement: () => void;
    element: GenieItem | undefined;
    elementsConfig: GeniePadElementsSettingItem[];
};

type State = {
    medicationElement: MedicationsEntity | undefined;
};
class GenieMedTable extends PureComponent<GenieMedTableProps, State> {
    REF_MAP: EkaFocosableElement[][] = [];
    state: State = {
        medicationElement: undefined,
    };

    componentDidUpdate = (prevProps: GenieMedTableProps): void => {
        const { element } = this.props;
        if (prevProps.element !== this.props.element) {
            this.setState({ medicationElement: element as MedicationsEntity });
        }
    };

    upsertMedication = (element: MedicationsEntity, index?: number) => {
        return upsertMedication(element, index);
    };

    closeMe = () => {
        const { clearElement } = this.props;
        clearElement();
    };

    saveElementInState = (element: MedicationsEntity) => {
        this.setState({
            medicationElement: element,
        });
    };

    saveElementInDb = () => {
        const { onSave } = this.props;
        const { medicationElement } = this.state;
        medicationElement && onSave(medicationElement);
        this.closeMe();
    };

    render() {
        const { elementsConfig } = this.props;
        const { medicationElement } = this.state;

        return (
            <Modal
                bodyStyle={{
                    overflowY: 'auto',
                    flex: '1 1 auto',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '0px',
                    backgroundColor: 'white',
                }}
                okButtonProps={{
                    className: 'primary-btn font-lato',
                    style: { color: 'white' },
                }}
                cancelButtonProps={{ className: 'neutral-btn font-lato' }}
                className="flex flex-col"
                title={
                    <div className="font-lato w-full font-700">
                        {`Edit ${medicationElement?.name}`}
                    </div>
                }
                visible={medicationElement ? true : false}
                onOk={this.saveElementInDb}
                okText="Save"
                onCancel={this.closeMe}
                width="80%"
                key={medicationElement?.id}
            >
                <div className="bg-white pl-16">
                    <MedTableRenderer
                        kind="Medicines"
                        elements={medicationElement ? [medicationElement] : []}
                        elementsConfig={elementsConfig}
                        upsertElement={this.saveElementInState}
                        isNameEditable={false}
                        containerId={MY_PROFILE_CONTAINER}
                        REF_MAP={this.REF_MAP}
                        hideFixNowStrip
                    />
                </div>
            </Modal>
        );
    }
}

export default connect((state: GlobalState) => ({
    elementsConfig: getGenieSetting(state, 'medElements') as GeniePadElementsSettingItem[],
}))(GenieMedTable);
